import { updateWishlist } from '@source/store/user';

import { getConstructionNumberIds } from './construction-numbers-id';

export const fillWishlist = () => {
    updateWishlist(getConstructionNumberIds());
};

export const emptyWishlist = () => {
    updateWishlist([]);
};
